import { useEffect, useState } from 'react';
import Image from 'next/image';
import Dropdown from '@/components/Home/Faqs/Dropdown';
import gsap from 'gsap';
import { PrismicRichText } from '@prismicio/react';
import TituloIlustracion from '../TituloIlustracion';

const Hero = ({ faqs }) => {
  const [isActive, setIsActive] = useState(null);

  useEffect(() => {
    gsap.fromTo(
      '.things-js',
      {
        scale: 0,
        rotate: '-90deg'
      },
      {
        scale: 1,
        rotate: 0,
        ease: 'back.out'
      }
    );
  }, []);

  const onClickToggle = (index) => {
    if (isActive === index) {
      setIsActive(false);
    } else {
      setIsActive(index);
    }
  };

  return (
    <section className="site-max relative pt-140 pb-155">
      <div className="site-grid">
        <div className="col-span-4 sm:col-span-5 sm:pl-18">
          <TituloIlustracion fontTitle="!text-40 sm:!text-48 !flex-col" />
          <div className="w-fit sm:ml-[16dvw] mb-30 sm:mb-0">
            <p className="p1 text-cyan-dark">
              Si tenés alguna otra dudas podés &nbsp; <br />
              <span className="font-semibold">contactarte con nuestro equipo</span>
            </p>
          </div>
        </div>
        <div className="sm:col-start-7 col-span-4 sm:col-span-6">
          {faqs.map((faq, index) => {
            return (
              <div key={index} className="dropdown-js">
                <Dropdown
                  question={faq.pregunta}
                  isActive={isActive === index}
                  toggle={() => onClickToggle(index)}
                >
                  {Array.isArray(faq.respuesta) ? (
                    <PrismicRichText field={faq.respuesta} />
                  ) : (
                    faq.respuesta
                  )}
                </Dropdown>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
export default Hero;
